module.exports = __webpack_public_path__ + "h5/img/funv-navc3.9390fbc2.png";